import { FullRouteNavItem, NavItem } from '../models/nav-item.model';
import { buildFullRouteNavItems } from '../utils/navbar.utils';

const navItems: NavItem[] = [
  {
    displayName: 'Grocy',
    faIconName: 'fa-cart-shopping',
    route: 'grocy',
    children: [
      { displayName: 'Journal', route: 'journal' },
      { displayName: 'Products', route: 'products' },
      { displayName: 'Seeds', route: 'seeds' },
      { displayName: 'Shopping Lists', route: 'shopping-lists' },
      { displayName: 'Stock', route: 'stock' },
    ],
  },
  {
    displayName: 'Stock',
    faIconName: 'fa-box',
    route: 'stock',
    children: [
      { displayName: 'Locations', route: 'locations' },
      { displayName: 'Product Categories', route: 'product-categories' },
      { displayName: 'Quantity Units', route: 'quantity-units' },
      { displayName: 'Seeds', route: 'seeds' },
      { displayName: 'Stores', route: 'stores' },
    ],
  },
  {
    displayName: 'Weather',
    faIconName: 'fa-cloud-sun',
    route: 'weather',
    children: [
      { displayName: 'Daily', route: 'daily' },
      { displayName: 'Hourly', route: 'hourly' },
    ],
  },

  { displayName: 'Settings', faIconName: 'fa-gear', route: 'settings/config' },
];

export const fullRouteNavItems: FullRouteNavItem[] = buildFullRouteNavItems(navItems);
